import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StandardTrainingCategoryViewModel } from 'src/app/models/standard-training-category/standard-training-category-view.model';

@Component({
  selector: 'app-provided-tenant-subscription-modal',
  standalone: false,
  templateUrl: './provided-tenant-subscription-modal.component.html',
  styleUrl: './provided-tenant-subscription-modal.component.scss',
})
export class ProvidedTenantSubscriptionModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
 
  @Input() tenantName: string = '';
  @Input() invitedDate: Date | null = null;
 
  @Input() trainingsCount = 0;
  @Input() categoriesCount = 0;
 
  @Input() 
  standardCategories: StandardTrainingCategoryViewModel[] = [];
 
  @Output() subscribe = new EventEmitter<string[]>();
  @Output() skip = new EventEmitter<void>();
 
  showMapping = false;
  disabledStandardCategoryIds: string[] = [];

  skipButtonOptions: any;
  subscribeButtonOptions: any;

  constructor(
    private translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.skipButtonOptions = {
      stylingMode: 'contained',
      type: 'default',
      text: this.translateService.instant(
        'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.DECIDE-LATER'
      ),
      onClick: () => this.onSkip()
    };

    this.subscribeButtonOptions = {
      stylingMode: 'contained',
      type: 'normal',
      text: this.translateService.instant(
        'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.UNLOCK-CONTENT'
      ),
      onClick: () => this.onSubscribe()
    };
  }

  toggleMappingSection(): void {
    this.showMapping = !this.showMapping;
  }
 
  onCategoryEnabledChanged(
    categoryId: string, enabled: boolean
  ): void {
    if (enabled) {
      this.disabledStandardCategoryIds =
        this.disabledStandardCategoryIds.filter(id => id !== categoryId);
    } 
    else if (
      !this.disabledStandardCategoryIds.includes(categoryId)
    ) {
      this.disabledStandardCategoryIds.push(categoryId);
    }
  }

  onSubscribe(): void {
    this.subscribe.emit(this.disabledStandardCategoryIds);
    this.close();
  }
 
  onSkip(): void {
    this.skip.emit();
    this.close();
  }
 
  private close(): void {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
